module.exports = __webpack_public_path__ + "static/img/yeswecan0011.91e9306.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/yeswecan0011.png
// module id = 577
// module chunks = 1